/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './common-tango-colorpicker.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../app/components/common-tango-colorpicker/common-tango-colorpicker.component';
const styles_CommonTangoColorpickerComponent:any[] = [i0.styles];
export const RenderType_CommonTangoColorpickerComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CommonTangoColorpickerComponent,data:{}});
function View_CommonTangoColorpickerComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',([] as any[]),
      (null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.pickColor(_v.context.$implicit)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n			'])),
      (_l()(),i1.ɵeld(2,0,(null as any),(null as any),0,'div',[['class','color-icon']],
          [[4,'background-color',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n			'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n		']))],(null as any),(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_0);
  });
}
function View_CommonTangoColorpickerComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'color-palette']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n		'])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CommonTangoColorpickerComponent_2)),i1.ɵdid(3,
          802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n	']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.colors;
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
export function View_CommonTangoColorpickerComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),6,'div',[['style',
      '']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n	'])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),0,'div',[['class','color-icon selected-color']],[[4,'background-color',
              (null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.CommonTangoColorpickerComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.toggleColorPalette(true)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n	'])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CommonTangoColorpickerComponent_1)),
      i1.ɵdid(5,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.CommonTangoColorpickerComponent = _v.component;
    const currVal_1:any = _co.showColorPalette;
    _ck(_v,5,0,currVal_1);
  },(_ck,_v) => {
    var _co:i3.CommonTangoColorpickerComponent = _v.component;
    const currVal_0:any = _co.selectedColor;
    _ck(_v,2,0,currVal_0);
  });
}
export function View_CommonTangoColorpickerComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-common-tango-colorpicker',
      ([] as any[]),(null as any),[['document','click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('document:click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onDocumentClick($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_CommonTangoColorpickerComponent_0,RenderType_CommonTangoColorpickerComponent)),
      i1.ɵdid(1,114688,(null as any),0,i3.CommonTangoColorpickerComponent,[i1.ElementRef],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CommonTangoColorpickerComponentNgFactory:i1.ComponentFactory<i3.CommonTangoColorpickerComponent> = i1.ɵccf('app-common-tango-colorpicker',
    i3.CommonTangoColorpickerComponent,View_CommonTangoColorpickerComponent_Host_0,
    {selectedColor:'selectedColor'},{colorChange:'colorChange'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/common-tango-colorpicker/common-tango-colorpicker.component.ngfactory.ts